
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getToken } from "../services/AuthToken";

/**
 * A wrapper for protected routes.
 * Redirects to login if no token is found.
 */
const AuthProtected = ({ children }) => {
  const location = useLocation();
  const token = getToken();

  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default AuthProtected;
